import React, { useEffect, useState } from 'react';

const LiveMatchControl = ({ scorecard, startInning, firstInnings, secondInnings, isStrikerAvaiable, endFirstInning, handleRunOut, currentInning, isRunOut, setIsRunOut, nonStrikerAvaiable, disableButtonFor3Seconds, isCurrentOver, handleWicket, isDisabled, showOutOptions, setShowOutOptions, loading, updateLiveMatchScore, nonStriker, striker, currentBowler, matchId, battingTeamPlayers, bowlingTeamPlayers, handleStrikerChange, updateOverAndBowler, handleNonStrikerChange, addNewBatmans, changeBowler }) => {
    const { match, innings } = scorecard ?? {};
    const [notOutPlayers, setNotOutPlayers] = useState([]);
    const [availableForNonStriker, setAvailableForNonStriker] = useState([]);
    const [runOutRuns, setRunOutRuns] = useState(0);

    const runningCurrentStatus = (innings?.find(inn => inn.innstatus === "in_progress" || inn.innstatus === "upcoming"));
    const firstInningStatus = innings?.find(inn => Number(inn.inning_no) === 1);
    const secondInningStatus = innings?.find(inn => Number(inn.inning_no) === 2);
    const canScore = Number(match?.totalOver || 0) > Number(currentInning?.overs || 0)
        && runningCurrentStatus?.innstatus === "in_progress"
        && Boolean(striker?.playerId && nonStriker?.playerId && currentBowler?.playerId);
    const isMatchFinished = secondInnings?.innstatus === 'completed' && firstInnings?.innstatus === 'completed';

    useEffect(() => {
        const getAvailablePlayers = () => {
            // Filter out players who are "out"
            const notOutPlayers = battingTeamPlayers.filter(player =>
                !currentInning?.batting?.some(inn =>
                    inn.playerId === player.playerId && inn.how_out !== 'out' // Check if the player is out
                )
            );

            // Exclude the current striker from the non-striker options
            const availableForNonStriker = notOutPlayers.filter(player => player.playerName !== striker?.playerName);

            setNotOutPlayers(notOutPlayers);
            setAvailableForNonStriker(availableForNonStriker);
        };

        getAvailablePlayers();
    }, [battingTeamPlayers, currentInning, striker?.playerName]);

    const handleStrikerChangeEvent = (e) => {
        addNewBatmans(e, "striker");
    };

    const handleNonStrikerChangeEvent = (e) => {
        addNewBatmans(e, "non-striker");
    };

    const submitScore = (action) => {
        disableButtonFor3Seconds();
        updateLiveMatchScore(action);
    };

    const submitWicket = (howOut, dismissedPlayerId = striker?.playerId, bowlerWicket = true) => {
        submitScore({
            runs: 0,
            totalRuns: 0,
            batterRuns: 0,
            isWicket: true,
            howOut,
            dismissedPlayerId,
            bowlerWicket,
        });
    };

    // if (!scorecard || !match || !innings) return <p>Loading live match...</p>;

    return (
        <>
          {scorecard && match && innings && (
                <div className="live-match-admin">
                    <div className="live-header">
                        <h3>🏏 Live Match Control Panel</h3>
                        <p>Update real-time match data manually</p>
                    </div>

                    <div className="match-summary">
                        <div className="score-box">
                            <h4>{match.teamA_name}</h4>
                            <p className="score">
                                {innings.find(inn => inn.batting_team_id === match.teamA_id)?.total_runs || 0}/
                                {innings.find(inn => inn.batting_team_id === match.teamA_id)?.wickets || 0}
                            </p>
                            <p className="overs">
                                Overs: {(innings.find(inn => inn.batting_team_id === match.teamA_id)?.overs || 0).toFixed(1)} / {match.totalOver}
                            </p>
                        </div>

                        <div className="score-box">
                            <h4>{match.teamB_name}</h4>
                            <p className="score">
                                {innings.find(inn => inn.batting_team_id === match.teamB_id)?.total_runs || "–"}/
                                {innings.find(inn => inn.batting_team_id === match.teamB_id)?.wickets || "–"}
                            </p>
                            <p className="overs">
                                {innings.find(inn => inn.batting_team_id === match.teamB_id)?.overs
                                    ? `Overs: ${(innings.find(inn => inn.batting_team_id === match.teamB_id)?.overs).toFixed(1)} / ${match.totalOver}`
                                    : "Yet to Bat"}
                            </p>
                        </div>
                    </div>

                    {currentInning?.wickets < 10 && (
                        <>
                            <div className="players-section">
                                <div className="player-card striker">
                                    <h5>Striker</h5>
                                    <p>{striker?.playerName || "-"} – {striker?.runs || 0} ({striker?.balls || 0})</p>
                                </div>

                                <div className="player-card non-striker">
                                    <h5>Non-Striker</h5>
                                    <p>{nonStriker?.playerName || "-"} – {nonStriker?.runs || 0} ({nonStriker?.balls || 0})</p>
                                </div>
                            </div>

                            {runningCurrentStatus?.innstatus === "in_progress" && (
                                <>
                                    {currentBowler && (
                                        <div className="players-section">
                                            <div className="player-card current-bowler">
                                                <h5>Current Bowler</h5>
                                                {Object.keys(currentBowler).length > 0 ? (
                                                    <p>{`${currentBowler?.playerName} - ${Number(currentBowler?.overs || 0).toFixed(1)} (${currentBowler?.runs_conceded || 0}/${currentBowler?.wickets || 0})`}</p>
                                                ) : (
                                                    <p>{`No Bowler`}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="openers d-flex gap-4 align-items-center">
                                        <div className="opener-select">
                                            <label>Striker:</label>
                                            <select
                                                value={striker?.playerName || ""}
                                                onChange={handleStrikerChangeEvent}
                                                className="form-select"
                                                disabled={isStrikerAvaiable}
                                            >
                                                <option>
                                                    Select Striker
                                                </option>
                                                {notOutPlayers.map((item, i) => (
                                                    <option key={i} value={item.playerName}>
                                                        {item.playerName} {`(${item?.playerRole})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="opener-select">
                                            <label>Non-Striker:</label>
                                            <select
                                                value={nonStriker?.playerName || ""}
                                                onChange={handleNonStrikerChangeEvent}
                                                className="form-select"
                                                disabled={nonStrikerAvaiable}
                                            >
                                                <option>
                                                    Select Non-Striker
                                                </option>
                                                {availableForNonStriker.map((item, i) => (
                                                    <option key={i} value={item.playerName}>
                                                        {item.playerName} {`(${item?.playerRole})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="opener-select">
                                            <label>Bowler:</label>
                                            <select
                                                value={currentBowler?.playerId || ""}
                                                onChange={(e) => changeBowler(e.target.value)}  // Pass playerId
                                                className="form-select"
                                                disabled={!!isCurrentOver}
                                            >
                                                <option>
                                                    Select Bowler
                                                </option>
                                                {bowlingTeamPlayers.map((item, i) => (
                                                    <option key={i} value={item.playerId}> 
                                                        {item.playerName} {`(${item?.playerRole})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </>
                            )}

                            {canScore && !isMatchFinished && (
                                <div className="control-panel my-4">
                                    <h5 className='mb-3'>Scoring Controls</h5>

                                    <div className="score-control-section">
                                        <div className="score-control-title">Bat Runs</div>
                                        <div className="buttons-grid score-buttons-grid">
                                            {[0, 1, 2, 3, 4, 5, 6].map((run) => (
                                                <button
                                                    key={run}
                                                    onClick={() => submitScore({ runs: run, totalRuns: run, batterRuns: run })}
                                                    disabled={isDisabled}
                                                >
                                                    {run}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="score-control-section">
                                        <div className="score-control-title">Extras</div>
                                        <div className="buttons-grid score-buttons-grid">
                                            <button disabled={isDisabled} onClick={() => submitScore({ runs: 0, totalRuns: 1, batterRuns: 0, bowlerRuns: 1, isWide: true, legalBall: false, strikeChangeRuns: 0 })}>Wide</button>
                                            <button disabled={isDisabled} onClick={() => submitScore({ runs: 0, totalRuns: 2, batterRuns: 0, bowlerRuns: 2, isWide: true, legalBall: false, strikeChangeRuns: 1 })}>Wide +1</button>
                                            <button disabled={isDisabled} onClick={() => submitScore({ runs: 0, totalRuns: 3, batterRuns: 0, bowlerRuns: 3, isWide: true, legalBall: false, strikeChangeRuns: 2 })}>Wide +2</button>
                                            <button disabled={isDisabled} onClick={() => submitScore({ runs: 0, totalRuns: 1, batterRuns: 0, bowlerRuns: 1, isNoBall: true, legalBall: false, strikeChangeRuns: 0 })}>No Ball</button>
                                            <button disabled={isDisabled} onClick={() => submitScore({ runs: 1, totalRuns: 2, batterRuns: 1, bowlerRuns: 2, isNoBall: true, legalBall: false, strikeChangeRuns: 1 })}>NB +1</button>
                                            <button disabled={isDisabled} onClick={() => submitScore({ runs: 4, totalRuns: 5, batterRuns: 4, bowlerRuns: 5, isNoBall: true, legalBall: false, strikeChangeRuns: 4 })}>NB +4</button>
                                            {[1, 2, 3, 4].map((run) => (
                                                <button
                                                    key={`bye-${run}`}
                                                    disabled={isDisabled}
                                                    onClick={() => submitScore({ runs: 0, totalRuns: run, batterRuns: 0, bowlerRuns: 0, isBye: true, strikeChangeRuns: run })}
                                                >
                                                    Bye {run}
                                                </button>
                                            ))}
                                            {[1, 2, 3, 4].map((run) => (
                                                <button
                                                    key={`leg-bye-${run}`}
                                                    disabled={isDisabled}
                                                    onClick={() => submitScore({ runs: 0, totalRuns: run, batterRuns: 0, bowlerRuns: 0, isLegBye: true, strikeChangeRuns: run })}
                                                >
                                                    LB {run}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="score-control-section">
                                        <div className="score-control-title">Wicket</div>
                                        <div className="buttons-grid score-buttons-grid">
                                            <button disabled={isDisabled} onClick={() => submitWicket("Caught out!", striker?.playerId, true)}>Caught</button>
                                            <button disabled={isDisabled} onClick={() => submitWicket("Bowled out!!", striker?.playerId, true)}>Bowled</button>
                                            <button disabled={isDisabled} onClick={() => submitWicket("LBW!", striker?.playerId, true)}>LBW</button>
                                            <button disabled={isDisabled} onClick={() => submitWicket("Hit Wicket!", striker?.playerId, true)}>Hit Wicket</button>
                                            <button disabled={isDisabled} onClick={() => submitWicket("Stumping!", striker?.playerId, true)}>Stumping</button>
                                            <button disabled={isDisabled} onClick={() => setIsRunOut(true)}>Run Out</button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isRunOut && (
                                <div className="score-control-section runout-panel">
                                    <div className="score-control-title">Run Out</div>
                                    <div className="runout-runs">
                                        <span>Runs completed</span>
                                        {[0, 1, 2, 3].map((run) => (
                                            <button
                                                key={`runout-${run}`}
                                                type="button"
                                                className={runOutRuns === run ? "active" : ""}
                                                onClick={() => setRunOutRuns(run)}
                                            >
                                                {run}
                                            </button>
                                        ))}
                                    </div>

                                    <div className="players-section">
                                        <button
                                            type="button"
                                            className="player-card striker"
                                            disabled={isDisabled}
                                            onClick={() => submitScore({
                                                runs: runOutRuns,
                                                totalRuns: runOutRuns,
                                                batterRuns: runOutRuns,
                                                bowlerRuns: 0,
                                                isWicket: true,
                                                howOut: "Run Out",
                                                batterPlayerId: striker?.playerId,
                                                dismissedPlayerId: striker?.playerId,
                                                bowlerWicket: false,
                                                strikeChangeRuns: runOutRuns,
                                            })}
                                        >
                                            <h5>Striker Out</h5>
                                            <p>{striker?.playerName}</p>
                                        </button>

                                        <button
                                            type="button"
                                            className="player-card non-striker"
                                            disabled={isDisabled}
                                            onClick={() => submitScore({
                                                runs: runOutRuns,
                                                totalRuns: runOutRuns,
                                                batterRuns: runOutRuns,
                                                bowlerRuns: 0,
                                                isWicket: true,
                                                howOut: "Run Out",
                                                batterPlayerId: striker?.playerId,
                                                dismissedPlayerId: nonStriker?.playerId,
                                                bowlerWicket: false,
                                                strikeChangeRuns: runOutRuns,
                                            })}
                                        >
                                            <h5>Non-Striker Out</h5>
                                            <p>{nonStriker?.playerName}</p>
                                        </button>
                                    </div>

                                    <button type="button" className="score-cancel-btn" onClick={() => setIsRunOut(false)}>
                                        Cancel Run Out
                                    </button>
                                </div>
                            )}

                            <div className="update-section mt-4">
                                {firstInningStatus?.innstatus === 'upcoming' && (
                                    <button className="btn-end" onClick={() => startInning(1)}>🏁 Start 1st Innings</button>
                                )}

                                {currentInning?.inning_no === 1 && currentInning?.innstatus === 'in_progress' && (
                                    <button className="btn-end" onClick={() => endFirstInning(1)}>🏁 End 1st Innings</button>
                                )}

                                {firstInningStatus?.innstatus === 'completed' && secondInningStatus?.innstatus === 'upcoming' && (
                                    <button className="btn-end" onClick={() => startInning(2)}>🏁 Start 2nd Innings</button>
                                )}

                                {currentInning?.inning_no === 2 && currentInning?.innstatus === 'in_progress' && (
                                    <button className="btn-end" onClick={() => endFirstInning(2)}>🏁 End 2nd Innings</button>
                                )}
                            </div>
                        </>
                    )}
                </div >
            )} 
        </>
    );
};

export default LiveMatchControl;

